<script lang="ts">
    import ErrorIcon from './ErrorIcon.svelte';
    import CloseErrorScreen from './CloseErrorScreen.svelte';
    import type { TMarket } from '$lib/services/market/types';
    import { spineBus } from '$lib/services/gatekeeper/MessageBus';
    import { COOKIES } from '$lib/services/legacy/standaloneRegistration/constants';
    import { deleteCookie } from '$lib/services/register/utils.frontend';
    import type { TFlowMessage } from '$lib/services/register/types';
    import Button from '$lib/components/Button/Button.svelte';

    export let auth: any;
    export let market: TMarket;
    export let error: TFlowMessage;
    export let localCode: String;

    console.error('Error in error component in Spine', error);
    const onCloseScreen = () => {
        deleteCookie(COOKIES.ERROR_NAME);
        window.location.href = `/${market?.slug}`;
    };

    const onTryAgain = () => {
        deleteCookie(COOKIES.ERROR_NAME);
        auth.logIn();
    };

    const onGetInTouch = () => {
        deleteCookie(COOKIES.ERROR_NAME);
        spineBus.publish('support', { kind: 'open' });
    };

    const errorTranslation = error?.translations?.find(
        (translation) => translation?.languages_code?.code === localCode
    );
</script>

<div
    class="fixed left-0 top-0 h-full w-full items-center justify-center overflow-y-auto bg-white p-md tablet:relative tablet:h-[40rem] tablet:w-[40.625rem] tablet:rounded-2xl tablet:p-lg"
>
    <div class="flex justify-between">
        <div><ErrorIcon /></div>
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div
            class="cursor-pointer"
            on:click={onCloseScreen}
            aria-roledescription="close"
            role="button"
            tabindex="0"
        >
            <CloseErrorScreen />
        </div>
    </div>
    <div class="flex h-[500px] flex-col">
        <div class="flex h-full flex-col pt-md">
            <div class="text-h-lg">{errorTranslation?.title || error?.key}</div>
            <div class="mt-md text-h-sm">
                {errorTranslation?.message}
            </div>
        </div>
        <div class="flex w-full justify-around gap-md">
            <div
                class="fixed bottom-0 left-0 flex w-full flex-col justify-between gap-xs p-md tablet:relative tablet:flex-row-reverse tablet:rounded-b-3xl tablet:p-[0px]"
            >
                <div class="tablet:w-1/2">
                    <Button theme="dark" on:click={onTryAgain}>
                        {errorTranslation?.btn_main_text}
                    </Button>
                </div>
                <div class="tablet:w-1/2">
                    <Button theme="dark" secodary on:click={onGetInTouch}>
                        {errorTranslation?.btn_secondary_text}
                    </Button>
                </div>
            </div>
        </div>
    </div>
</div>
